import Vue from 'vue';
import nl from 'vee-validate/dist/locale/nl';
import VeeValidate, { Validator } from 'vee-validate';

import Unique from '../helpers/validation/Unique';


Vue.use(VeeValidate, {mode: 'eager'});
Validator.localize('nl', nl);
Validator.extend('unique', Unique);
Validator.extend('phone', {
    validate: value => value.length === 10,
    message: 'Telefoonnummer moet bestaan uit 10 cijfers.'
});
